import Http from '../../utils/Http';
import * as Order from '../../store/allStates/order/actions';
// import * as Order from "../../../Redux/allStates/order/actions";
import { Dispatch, AnyAction } from 'redux';
import Transformer from '../../utils/Transformer';
import { admin_prefix } from '../../../configs/constant';

// import { Storage } from "src/configs/lib";
const { Storage, platform } = require('../../../configs/lib');
const { type } = require('../../../configs/constant');
export function getproductlistfororder(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/product-item`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}
export function getcataloguelistfororder(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/catalog`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function saveorder(requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}order/save-order`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function handlecheckCartonAPI(requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}order/check-carton-quantity`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function handlecheckFinalCartonAPI(requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}order/check-final-carton-quantity`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getcartitems(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/get-cart`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    dispatch(Order.cart(data.data.rows));
                    return resolve(data);
                })
                .catch((err) => {
                    dispatch(Order.cart([]));
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function getcartitemsforAdmin(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/get-cart`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function getupdatedcartitemsofbuyerforadmin(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/get-cart`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    dispatch(Order.cart(data.data.rows[0].order_details));
                    dispatch(Order.grossAmount(data.data.rows[0].gross_amount));
                    return resolve(data);
                })
                .catch((err) => {
                    dispatch(Order.cart([]));
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function SubmitComment(comment: any, orderId: any) {
    let comments = {
        comment: comment,
    };
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            const urlstring = `${admin_prefix}order/save-comment-order/${orderId}`;
            Http.post(urlstring, comments)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        errorMsg: '',
                        statusCode,
                    };
                    data.errorMsg = err.response.data.message;
                    return reject(data);
                });
        });
}
export function getbuyercartlistforadmin(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            // console.log('LISTING CART FOR MULTIPLE BUYERS API FOR ADMIN');
            Http.get(`${admin_prefix}order/get-admin-cart`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    dispatch(Order.cart([]));
                    return resolve(data);
                })
                .catch((err) => {
                    dispatch(Order.cart([]));
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getbuyercartforadmin(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            // console.log('EDIT AND DELETE CART API FOR ADMIN');
            Http.get(`${admin_prefix}order/get-admin-cart`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    dispatch(Order.cart(data.data.rows[0].order_details));
                    dispatch(Order.grossAmount(data.data.rows[0].gross_amount));
                    return resolve(data);
                })
                .catch((err) => {
                    dispatch(Order.cart([]));
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function cartItemDelete(id: any, user_id?: any, requestData?: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.delete(`${admin_prefix}order/delete-cart-items/${id}/${user_id}`, {
                params: requestData,
            })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function updateitem(id: any, requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.put(`${admin_prefix}order/edit-cart/${id}`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function submitOrder(requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}order/submit-order`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getorderhistorylist(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/buyer-order-history`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getbuyercartforadminforone(filter?: any) {
    // Main PlaceOrder From Admin
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            // console.log('Get ADMIN CART For PlaceOrder For ADMIN');
            Http.get(`${admin_prefix}order/get-admin-cart`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    dispatch(Order.cart([]));
                    dispatch(Order.cart(data.data.rows[0].order_details));
                    dispatch(Order.grossAmount(data.data.rows[0].gross_amount));
                    dispatch(Order.companyName(data.data.rows[0].user.company_name));
                    dispatch(Order.shopName(data.data.rows[0].user.shop_name));
                    localStorage.setItem('orderid', data.data.rows[0]._id);
                    return resolve(data);
                })
                .catch((err) => {
                    dispatch(Order.cart([]));
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getcartlistorderbycustomer(filter?: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/get-cart`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    // Redux store data passing
                    dispatch(Order.cart(data.data.rows));
                    if (platform === 'Mobile') {
                        Storage.setItem('orderid', data.data.rows[0].order_id);
                    } else {
                        localStorage.setItem('orderid', data.data.rows[0].order_id);
                    }
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    dispatch(Order.cart([]));
                    return reject(data);
                });
        });
}

export function getadminsalesmanorderhistorylist(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/order-history`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function buyerEditCart(data: any, gross_amount: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            dispatch(Order.cart(data));
            dispatch(Order.grossAmount(gross_amount));
        });
}

export function cancelorder(id: any, isBuyerOrderHistory: boolean = false) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}order/cancel-order/${id}`, null, {
                params: { buyer_order_history: isBuyerOrderHistory },
            })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function sendmail(requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}order/send-mail`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getorderbylist() {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}dropdown/order-by-dropdown`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getsubmittedbylist() {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}dropdown/submitted-by-dropdown`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function statuschangeorder(id: any, requestData: any, isBuyerOrderHistory: boolean = false) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}order/status-change/${id}`, requestData, {
                params: { buyer_order_history: isBuyerOrderHistory },
            })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function refreshproductwithWMS(requestData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}order/refresh-place-order`, requestData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function placeOrderHistoryById(id: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/order-history-by-id/${id}`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function finalOrderPrice(id: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/final-order-price/${id}`)
                .then((res) => {
                    var UserType = localStorage.getItem('user_type');
                    const data = Transformer.fetch(res.data);
                    if (UserType !== type.buyer.toString()) {
                        dispatch(Order.finalOrderPrice(data.data));
                    }
                    return resolve(data);
                })
                .catch((err) => {
                    dispatch(Order.finalOrderPrice(''));
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}
export function finalOrderPrice_Mobile(id: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/final-order-price/${id}`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    dispatch(Order.finalOrderPrice(data.data));
                    return resolve(data);
                })
                .catch((err) => {
                    dispatch(Order.finalOrderPrice(''));
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}
export function saveOrderComment(id: any, requestedData: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.post(`${admin_prefix}order/save-comment-order/${id}`, requestedData)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    dispatch(Order.finalOrderPrice(''));
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function getinvoicehistory(filter: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/invoice-history`, { params: filter })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function removecartapi(orderid: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.delete(`${admin_prefix}order/remove-cart/${orderid}`)
                .then((res) => {
                    dispatch(Order.cart([]));
                    dispatch(Order.grossAmount(0));
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;

                    return reject(data);
                });
        });
}

export function refreshorderwithWMS() {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/sync-order-to-wms`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function getOrderHistoryProductsList(id: any) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}order/order-history-products/${id}`)
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}

export function getOrderDiscountInfoCategoryWise(id: any, orderId: string) {
    return (dispatch: Dispatch<AnyAction>) =>
        new Promise((resolve, reject) => {
            Http.get(`${admin_prefix}discounts/discount-offer-category-products-cart-info/${id}`, {
                params: {
                    orderId: orderId,
                },
            })
                .then((res) => {
                    const data = Transformer.fetch(res.data);
                    return resolve(data);
                })
                .catch((err) => {
                    const statusCode = err.response.status;
                    const data = {
                        error: null,
                        statusCode,
                    };
                    data.error = err.response.data;
                    return reject(data);
                });
        });
}
